export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lm" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FF5A1E" />
        <stop offset="1" stopColor="#9D4EDD" />
      </linearGradient>
    </defs>
    <path d="M14 30a18 18 0 0 1 36 0z" fill="url(#lm)" />
    <rect x="14" y="35" width="36" height="4" rx="2" fill="#FF5A1E" />
    <rect x="19" y="43" width="26" height="4" rx="2" fill="#C45AB0" />
    <rect x="25" y="51" width="14" height="4" rx="2" fill="#9D4EDD" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-lg font-extrabold uppercase tracking-wide text-white">Fallsview</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-300">Summer Concert Series</span>
    </span>
  </span>
);
